<template>
    <div class="dashborad container">
        <div class="dashborad-left">
            <div class="stat-item">
                <div class="common-title">
                    2024年度累计概况
                </div>
                <el-card class="box-card">
                    <div class="stat-num-list">
                        <div class="stat-num-item">
                            <div class="title">总用户</div>
                            <div class="num">
                              <template v-if="!userStat.totalCount">-</template>
                              <count-to v-else :endVal='userStat.totalCount'></count-to>
                              人
                            </div>
                        </div>
                        <div class="stat-num-item">
                            <div class="title">总销售</div>
                            <div class="num">
                              <template v-if="!saleStat.totalCount">-</template>
                              <count-to v-else :endVal='saleStat.totalCount'></count-to>
                              单
                            </div>
                        </div>
                        <div class="stat-num-item">
                            <div class="title">可提现</div>
                            <div class="num">
                              <template v-if="!incomeStat.canWithdrawAmount">-</template>
                              <count-to v-else :endVal='incomeStat.canWithdrawAmount'></count-to>
                              元
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="stat-item">
                <div class="common-title">
                    2024年度收益情况
                </div>
                <el-card class="box-card">
                    <div class="stat-num-list">
                        <div class="stat-num-item">
                            <div class="title">昨日收益</div>
                            <div class="num">
                              <template v-if="!incomeStat.yesterdayAmount">-</template>
                              <count-to v-else :endVal='incomeStat.yesterdayAmount'></count-to>
                              人
                          </div>
                        </div>
                        <div class="stat-num-item">
                            <div class="title">本月收益</div>
                            <div class="num">
                              <template v-if="!incomeStat.thisMonthAmount">-</template>
                              <count-to v-else :endVal='incomeStat.thisMonthAmount'></count-to> 单</div>
                        </div>
                        <div class="stat-num-item">
                            <div class="title">累计收益</div>
                            <div class="num">
                              <template v-if="!incomeStat.grandTotalAmount">-</template>
                              <count-to v-else :endVal='incomeStat.grandTotalAmount'></count-to>元</div>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="part-stat">
              <el-card>
                <div class="common-title">
                  用户省份分析
                </div>
                <!-- <div ref="provinceRef" style="height: 500px; width: 100%"></div> -->
              </el-card>
            </div>
        </div>
        <div class="dashborad-main">
          <div class="part">
            <div class="stat-top">
              <div class="common-title">
                数据概览
              </div>
              <div class="date">
                数据时间：{{ '2023/11/14 16:00' }}
              </div>
            </div>
            <div class="stat-num-list">
              <div class="stat-num-item bg">
                <el-card>
                  <div class="title">
                    今日访问数
                  </div>
                  <div class="num">
                    <template v-if="!userStat.todayVisitCount">-</template>
                    <count-to v-else :endVal='userStat.todayVisitCount'></count-to>
                    人
                  </div>
                  <div class="tip">
                    较昨日 <span>
                      {{ userStat.compareYesterdayVisitCount }}
                    </span>
                  </div>
                </el-card>
              </div>
              <div class="stat-num-item bg">
                <el-card>
                  <div class="title">
                    今日完善信息数
                  </div>
                  <div class="num">
                    <template v-if="!userStat.todayAddCount">-</template>
                    <count-to v-else :endVal='userStat.todayAddCount'></count-to>
                    人
                  </div>
                  <div class="tip">
                    较昨日 <span>
                      {{ userStat.compareYesterdayAddCount }}
                    </span>
                  </div>
                </el-card>
              </div>
              <div class="stat-num-item bg">
                <el-card class="box-card">
                  <div class="title">
                    今日线上销售数
                  </div>
                  <div class="num">
                    <template v-if="!saleStat.todayCount">-</template>
                    <count-to v-else :endVal='saleStat.todayCount'></count-to>
                    人
                  </div>
                  <div class="tip">
                    较昨日 <span>
                      {{ saleStat.thanYesterdayAddCount }}
                    </span>
                  </div>
                </el-card>
              </div>
              <div class="stat-num-item bg">
                <el-card class="box-card">
                  <div class="title">
                    今日激活码激活
                  </div>
                  <div class="num">
                    <template v-if="!codeStat.todayCount">-</template>
                    <count-to v-else :endVal='codeStat.todayCount'></count-to>
                    人
                  </div>
                  <div class="tip">
                    较昨日 <span>
                      {{ codeStat.thanYesterdayAddCount }}
                    </span>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
          <div class="part line">
            <div class="part-chart">
              <div class="chart-item">
                <el-card>
                  <div class="common-title">
                    线上订单详情
                  </div>
                  <div class="common-date">
                    数据时间：{{ '2023/11/07' }} - {{ '2023/11/14' }}
                  </div>
                  <div ref="onlineOrderRef" style="height: 400px; width: 100%"></div>
                </el-card>
              </div>
              <div class="chart-item">
                <el-card>
                  <div class="common-title">
                    激活码激活情况
                  </div>
                  <div class="common-date">
                    数据时间：{{ '2023/11/07' }} - {{ '2023/11/14' }}
                  </div>
                  <div ref="activeCodeRef" style="height: 400px; width: 100%"></div>
                </el-card>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import countTo from 'vue-count-to'
import * as echarts from 'echarts'
// 微信图表样式
import chartTheme from './theme2.json'

export default {
    components: {
        countTo
    },
    data() {
        return {
            userStat: {},
            codeStat: {},
            saleStat: {},
            incomeStat: {},
            orderChartData: [],
            codeActiveData: []
        }
    },
    methods: {
        // 折线图
        setLineChart(refName, map) {
            const mapList = Object.keys(map)
            let xList = []
            const seriesList = mapList.map((v, index) => {
                if (index === 0) {
                    const tempItem = map[v]
                    xList = tempItem.map((v) => v.day)
                }
                const data = map[v].map((v) => v.count)
                return {
                    name: v,
                    type: 'line',
                    smooth: true,
                    data
                }
            })
            const chartDom = this.$refs[refName]
            const myChart = echarts.init(chartDom, 'custom')
            const option = {
                xAxis: {
                    type: 'category',
                    data: xList,
                    boundaryGap: false
                },
                yAxis: {
                    type: 'value'
                },
                series: seriesList,
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: mapList,
                    right: 20,
                    icon: 'circle'
                },
                grid: {
                    top: 30,
                    right: 50,
                    bottom: 30,
                    left: 50
                }
            }
            myChart.setOption(option)
        },
        getData() {
            this.getUserStat()
            this.getCodeStat()
            this.getSaleStat()
            this.getIncomeStat()
        },
        getUserStat() {
            this.$api.data.getUserStat().then((res) => {
                if (res.success && res.data) {
                    this.userStat = res.data
                }
            })
        },
        getCodeStat() {
            this.$api.data.getCodeStat().then((res) => {
                if (res.success && res.data) {
                    this.codeStat = res.data
                }
            })
        },
        getSaleStat() {
            this.$api.data.getSaleStat().then((res) => {
                if (res.success && res.data) {
                    this.saleStat = res.data
                }
            })
        },
        getIncomeStat() {
            this.$api.data.getIncomeStat().then((res) => {
                if (res.success && res.data) {
                    this.incomeStat = res.data
                }
            })
        },
        getOrderChart() {
            this.$api.data.getOrderChartData().then((res) => {
                if (res.success) {
                    this.orderChartData = res.data
                    const map = {}
                    res.data.forEach((v) => {
                        if (map[v.countName]) {
                            map[v.countName].push({
                                ...v,
                                count: v.countNumber
                            })
                        } else {
                            map[v.countName] = [{
                                ...v,
                                count: v.countNumber
                            }]
                        }
                    })
                    this.setLineChart('onlineOrderRef', map)
                }
            })
        },
        getCodeActiveChart() {
            this.$api.data.getCodeActiveChartData().then((res) => {
                if (res.success) {
                    this.codeActiveData = res.data
                    const map = {}
                    res.data.forEach((v) => {
                        if (map[v.countName]) {
                            map[v.countName].push({
                                ...v,
                                count: v.countNumber
                            })
                        } else {
                            map[v.countName] = [{
                                ...v,
                                count: v.countNumber
                            }]
                        }
                    })
                    this.setLineChart('activeCodeRef', map)
                }
            })
        },
        // 获取省份统计
        getProvinceChart() {
            const chartDom = this.$refs['provinceRef']
            const myChart = echarts.init(chartDom, 'custom')
            const option = {
                xAxis: {
                    type: 'value'
                },
                yAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                series: [
                    {
                        data: [120, 200, 150, 80, 70, 110, 130],
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ]
            }
            myChart.setOption(option)
        }
    },
    mounted() {
        this.getData()
        this.getOrderChart()
        this.getCodeActiveChart()
        this.getProvinceChart()
    },
    created() {
        // 注册主题
        echarts.registerTheme('custom', chartTheme)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Manager/Sys/SaleDashboard.vue